import List from './List';
import Edit from './Edit';

export {
    List,
    Edit,
};
